const  financialYearArray = ["All","2018-19","2019-20","2020-21"];
export default financialYearArray;